<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getApplication()" />
    <div class="hero flex-1" v-else>
        <div class="hero-content flex-col lg:flex-row">
            <div class="card bg-white m-auto max-w-3xl">
                <div class="card-body p-4 sm:p-5 md:p-8">
                    <img :src="application.logo" class="w-32 md:w-36 mx-auto" />
                    <div class="text-center mt-3">
                        <h1 class="text-lg font-bold">{{ __('Web application') }} {{ application.name }}</h1>
                        <p class="py-6" v-html="application.description"></p>
                        <a :href="application.custom_url" class="btn btn-primary">{{ __('Download the application')}}</a>
                        <!-- <button class="btn btn-primary" @click="installApplication">{{ __('Install the application')}}</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, computed } from "vue";
import useHome from "../../../composables/shop/home";
const { application, getApplication, installApplication,errors, loading } = useHome();
onMounted(() => getApplication());
</script>